'use strict';

function ctrl($scope, $http, $location, $window, $timeout) {
    let model = this;
    // delete any user token on page visit
    delete $window.sessionStorage.token;
    // set up user scope object
    model.user = {};
    model.email = function (form, user) {
        if (form.$valid) {
            $http.post(api+'/auth/forgotpass', { email: model.user.email })
                .success(function (user) {
                    model.disableSubmit = true;
                    model.emailresponse = 'Reset link sent to '+model.user.email+'. Redirecting in 10 seconds.';
                    model.tt = $timeout(function () {
                        $location.url('/login');
                    }, 10000, true);
                    $scope.$on('$destroy', function () {
                        $timeout.cancel(model.tt);
                    });
                })
        } else {
            model.disableSubmit = false;
            model.emailresponse = 'Email not valid.';
       }
    }
}

ctrl.$inject = ['$scope', '$http', '$location', '$window', '$timeout'];
module.exports = ctrl;


/** WEBPACK FOOTER **
 ** ./src/auth/controllers/forgot.js
 **/